import Alpine from 'alpinejs';

Alpine.data('dialCodes', () => ({
  isOpen: false,
  availableFilters: [],
  filters: '48',
  init(filters, value) {
    if (filters && JSON.parse(filters)) {
      const filts = JSON.parse(filters);

      this.availableFilters = filts;
    }

    if (value) {
      this.filters = value;
    }
  },
  getFilterName() {
    const filter = this.availableFilters.find(
      (filter) => filter.value == this.filters
    );

    if (filter) return filter.title;
  },

  handleSelect(value) {
    if (this.filters === value) {
      this.filters = '';
      this.$dispatch('dial-codes', {
        by: '',
      });
      return;
    }

    this.filters = value;

    this.$dispatch('dial-codes', {
      by: value,
    });
  },
}));
